// extracted by mini-css-extract-plugin
module.exports = {"cardText":"parts-card_cardText__mV8C3","cardImage":"parts-card_cardImage__pOt3R"};